function app(state = { alerts: [], popUp: null }, action) {
    switch (action.type) {
        case 'SHOW_ERROR': {
            const { message, error } = action;
            const type = 'danger';
            const id = (new Date()).getTime();
            console.log('ERROR', message, error);
            const { alerts } = state;
            return {
                ...state,
                alerts: alerts.concat([{ id, type, message }]),
            };
        }
        case 'SHOW_ERROR_POPUP': {
            const { message, error, description, custom, cta, showNoCta } = action;
            console.log('ERROR', message, error);
            return {
                ...state,
                popUp: {
                    message,
                    error,
                    description,
                    custom,
                    cta,
                    showNoCta,
                },
            };
        }
        case 'SHOW_WARNING': {
            const { message } = action;
            const type = 'warning';
            const id = (new Date()).getTime();
            console.log('WARNING', message);
            const { alerts } = state;
            return {
                ...state,
                alerts: alerts.concat([{ id, type, message }]),
            };
        }
        case 'SHOW_INFO': {
            const { message } = action;
            const type = 'info';
            const id = (new Date()).getTime();
            console.log('ERROR', message);
            const { alerts } = state;
            return {
                ...state,
                alerts: alerts.concat([{ id, type, message }]),
            };
        }
        case 'SHOW_SUCCESS': {
            const { message } = action;
            const type = 'success';
            const id = (new Date()).getTime();
            console.log('SUCCESS', message);
            const { alerts } = state;
            return {
                ...state,
                alerts: alerts.concat([{ id, type, message }]),
            };
        }

        case 'SHOW_SUCCESS_POPUP': {
            const { message, description, custom, cta, showNoCta } = action;
            return {
                ...state,
                popUp: {
                    message,
                    description,
                    custom,
                    cta,
                    showNoCta,
                },
            };
        }
        case 'DISMISS_NOTIFICATION': {
            console.log('DISMISS_NOTIFICATION', action, state);
            // remove index from the array
            const { alerts } = state;
            return {
                ...state,
                alerts: [...alerts.slice(0, action.index), ...alerts.slice(action.index + 1)],
            };
        }
        case 'DISMISS_NOTIFICATION_POPUP':
            console.log('DISMISS_NOTIFICATION_POPUP', action, state);
            // remove index from the array
            return {
                ...state,
                popUp: null,
            };
        default:
            return state;
    }
}

export default app;
